<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="请输入标题或发布者"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-cascader
        size="small"
        v-model="region"
        :options="regionData"
        :props="{ expandTrigger: 'hover', value: 'value' }"
        class="handle-input mr10"
      ></el-cascader>
      <el-select
        class="mr10"
        clearable
        v-model="status"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in statusData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        class="mr10"
        clearable
        v-model="auditStatus"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in auditStatusData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column label="封面" width="190px" align="center">
        <template #default="scope">
          <el-image
            fit="cover"
            class="cover"
            v-if="scope.row.cover"
            :src="$utils.fileUrl(scope.row.cover)"
            :preview-src-list="[`${$utils.fileUrl(scope.row.cover)}`]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column header-align="center" prop="title" label="标题">
      </el-table-column>
      <el-table-column
        prop="companyName"
        align="center"
        label="发布者"
      ></el-table-column>
      <el-table-column align="center" label="发布时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.createTime, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="地区" align="center" prop="region">
      </el-table-column>
      <el-table-column label="价格" align="center">
        <template #default="scope"> {{ scope.row.price }}元 </template>
      </el-table-column>

      <el-table-column label="订单数" align="center">
        <template #default="scope">
          <li>{{ scope.row.orderNumber }}</li>
          <li>
            <el-button size="mini" type="text" @click="link(scope.row)"
              >查看详情</el-button
            >
          </li>
        </template>
      </el-table-column>

      <el-table-column label="详情" align="center">
        <template #default="scope">
          <el-button size="mini" type="text" @click="getInfo(scope.row)"
            >产品详情</el-button
          >
        </template>
      </el-table-column>

      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.auditStatus === 1"
            @click="handleEdit(scope.row, 3)"
            >禁止展示</el-button
          >
          <el-button
            type="warning"
            size="mini"
            v-if="scope.row.auditStatus === 3"
            @click="handleEdit(scope.row, 1)"
            >恢复展示</el-button
          >
          <el-button type="danger" size="mini" @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 股权详情 -->
    <el-dialog
      title="详情"
      v-model="dialog"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <div class="cover-title">
          <div
            class="cover"
            :style="`background-image:url(${$utils.fileUrl(itemData.cover)})`"
          ></div>
          <div class="title-name">
            <li>{{ itemData.title }}</li>
            <li>{{ itemData.companyName }}</li>
          </div>
        </div>
        <el-form size="mini" label-position="top" inline>
          <div>
            <el-form-item>
              {{ itemData.status === 0 ? "下架" : "上架" }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>价格：</span>
              {{ itemData.price }}元
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>发布时间：</span>
              {{ $utils.formatDate(itemData.createTime, "yyyy-MM-dd hh:mm") }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>地区：</span>
              {{ itemData.region }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="产品说明：">
              {{ itemData.description }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="公司图集：">
              <div class="atlas">
                <template v-for="(item, index) in itemData.img">
                  <div
                    :key="index"
                    v-if="item"
                    :style="`background-image:url(${$utils.fileUrl(item)})`"
                  ></div>
                </template>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialog = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      region: [""],
      status: "",
      auditStatus: "",
      statusData: [
        { label: "全部", value: "" },
        { label: "下架", value: 0 },
        { label: "上架", value: 1 },
      ],
      auditStatusData: [
        { label: "全部", value: "" },
        { label: "审核通过", value: 1 },
        { label: "禁止展示", value: 3 },
      ],
      itemData: {},
      dialog: false,
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        name: this.searchName,
        status: this.status,
        auditStatus: this.auditStatus,
        region: this.region.toString(),
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.product.list.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    handleEdit(data, status) {
      if (!this.loading) {
        const text = status === 1 ? "是否确认恢复？" : "是否确认禁止展示？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const params = {
                id: data.id,
                status: status,
              };
              const res = await this.$api.product.review.setData(params);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                this.$message.success("操作成功！");
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    getInfo(data) {
      this.itemData = data;
      this.itemData.img = [];
      for (let i = 1; i <= 10; i++) {
        if (data[`img${i}`]) {
          this.itemData.img.push(data[`img${i}`]);
        }
      }
      this.dialog = true;
    },
    link(data) {
      this.$store.dispatch("data/setData", data);
      this.$router.push(`/product/order/${data.id}`);
    },
    // 删除
    delData(data) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: data.id,
            };
            const res = await this.$api.product.list.delData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          } catch (error) {
            this.loading = false;
            this.$loading.done();
          }
        })
        .catch(() => {});
    },
  },
  created() {
    this.getData();
  },
  computed: {
    regionData() {
      let data = [
        {
          label: "全国",
          value: "",
        },
      ];
      let region = this.$utils.getRegion();
      region.forEach((item) => {
        let i = {
          label: item.label,
          value: item.label,
          children: [],
        };
        if (item.children) {
          if (item.children.length > 1) {
            i.children = item.children.map((j) => {
              return {
                label: j.label,
                value: j.label,
              };
            });
          } else {
            i.children.push({
              label: "市辖区",
              value: "市辖区",
            });
          }
        } else {
          i.children.push({
            label: item.label,
            value: item.label,
          });
        }
        data.push(i);
      });

      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  display: inline-block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  h2 {
    font-size: 1rem;
    font-weight: 500;
    padding: 5px 0;
    color: $--color-primary;
  }

  .atlas {
    display: flex;
    flex-wrap: wrap;

    & > div {
      width: 160px;
      height: 90px;
      margin-bottom: 10px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      padding: 0;
    }
  }
}
</style>